"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorToObject = void 0;
var errorToObject = exports.errorToObject = function errorToObject(error) {
  var _ref = error || {},
    name = _ref.name,
    message = _ref.message,
    stack = _ref.stack;
  return {
    type: name,
    message: message,
    stack: stack
  };
};